import { IndicatorEntity } from '@core/type/api';

export const getDealIndicator = (indicator: IndicatorEntity): IndicatorEntity => {
  if (indicator.deal) {
    return {
      ...indicator,
      percentage: indicator.deal.percentage,
      amount: indicator?.amount - indicator.deal.amount,
    };
  }

  return indicator;
};
